module.exports = __webpack_public_path__ + "img/footer_logo_nisum.248039c4.webp";